import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
function About() {
  return (
    <>
      <div id="about-section">
        <Particle />
        <Container fluid className="about-section" id="about-section">
          <Container>
            <Row style={{ justifyContent: "center", padding: "10px" }}>
              <Col
                md={7}
                style={{
                  justifyContent: "center",
                  paddingTop: "30px",
                  paddingBottom: "50px",
                }}
              >
                <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                  Let Me   <strong className="purple">introduce</strong> Myself
                </h1>
                <Aboutcard />
              </Col>
              <Col
                md={5}
                style={{ paddingTop: "120px", paddingBottom: "50px" }}
                className="about-img"
              >
                <img src={laptopImg} alt="about" className="img-fluid" />
              </Col>
            </Row>
            <h1 className="project-heading">
              Technical  <strong className="purple">Skills </strong>
            </h1>
            <Techstack />
          </Container>
        </Container>
      </div>

    </>
  );
}
export default About;